import { Ellipsis, Pencil, PhoneForwardedIcon, Copy, Trash2 } from "lucide-react";
import { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, deleteDoc } from "firebase/firestore";

const ContactCardTop = ({ selectedContact, clickable, setSelectedContact, setShowContact, setContactCalled, selectedList, uid, setContacts, setShowEditContact, menu }) => {
  const [showContactDropdown, setShowContactDropdown] = useState(false);

  const handleShowContact = () => {
    if (clickable) {
      setShowContact(true);
      setSelectedContact(selectedContact);
    }
  }

  const call = ({ e, selectedContact }) => {
    e.stopPropagation();
    if (setSelectedContact) {
      setContactCalled(selectedContact);
    }
    window.location.assign('zoomphonecall:' + selectedContact.phone);
  }

  const handleShareContact = () => {
    const shareableContactInfo = `
${selectedContact.name || "(Name)"}
${selectedContact.title || "(Title)"}
${selectedContact.company || "(Conpany)"}
${selectedContact.phone || "(Phone)"}
${selectedContact.notes[selectedContact.notes.length - 1]?.status || "(Status)"}
${selectedContact.notes[selectedContact.notes.length - 1]?.noteText || "(Note)"}
`;
    navigator.clipboard.writeText(shareableContactInfo);
    alert(`Contact info for ${selectedContact.name} was copied to clipboard.`);
  }

  const handleDeleteContact = async () => {
    const permission = window.confirm(`Are you sure you want to delete all contact info and call history for ${selectedContact.name || "this contact"}?\n\nThis action can't be undone.`);
    if (permission) {
      const contactDocRef = doc(db, 'autodialer', 'users', 'ids', uid, 'lists', selectedList, 'contacts', selectedContact.id);
      await deleteDoc(contactDocRef);
      setContacts(prev => {
        const i = prev.findIndex(contact => contact.id === selectedContact.id);
        const next = [...prev];
        next.splice(i, 1);
        return next;
      });
      setShowContact(false);
    }
  }

  useEffect(() => {
    const hideDropdown = () => {
      setShowContactDropdown(false);
    };
    document.addEventListener('click', hideDropdown);
    return () => document.removeEventListener('click', hideDropdown);
  }, []);

  return (
    <div className='contact-card-top' onClick={() => handleShowContact()}>
      <div className='contact-card-name'>
        {selectedContact.name || "(Name)"}
        {
          menu &&
          <button
            className="menu-btn"
            onClick={(e) => { e.stopPropagation(); setShowContactDropdown(!showContactDropdown) }}
          >
            <Ellipsis size={"1.2rem"} color={"var(--neutral-400)"} />
          </button>
        }
      </div>
      {
        showContactDropdown &&
        <div className='drop-down'>
          <div
            onClick={() => handleShareContact()}
          >
            Copy <Copy size={'1.2rem'} color={'var(--neutral-400)'} />
          </div>
          <div
            onClick={() => { setShowEditContact(true); setShowContact(false) }}
          >
            Edit <Pencil size={'1.2rem'} color={'var(--neutral-400)'} />
          </div>
          <div
            onClick={() => handleDeleteContact()}
          >
            Delete <Trash2 size={'1.2rem'} color={'var(--neutral-400)'} />
          </div>
        </div>
      }
      <div className='contact-card-info'>
        <div>
          <div>{selectedContact.title || "(Title)"}</div>
          <div>{selectedContact.company || "(Company)"}</div>
        </div>
        <div>
          <div className='inline-text-btn-wrapper'>
            {selectedContact.phone || "(Phone)"}
            <button className='menu-btn' onClick={(e) => call({ e: e, selectedContact: selectedContact })}>
              <PhoneForwardedIcon size={'1.2rem'} />
            </button>
          </div>
          <div>{selectedContact.email || "(Email)"}</div>
        </div>
      </div>
    </div>
  );
}

export default ContactCardTop;